import store from '../app/store.js';
// import ConstOffsetTimeZone from '../../main-layout/sidebar/save-system-setting/Const';
import ConstOffsetTimeZone from '../main-layout/sidebar/save-system-setting/Const';
import moment from 'moment';
const FORMAT_DATE = 'YYYY-MM-DD';
const DEFAULT_TIMEZONE = '+07:00';

export const formatDate = (dateTime, isStart) => {
  const timeZone = store.getState()['MAIN_LAYOUT:SIDEBAR:'].settingSystem
    .dataSystem.timeZone;
  const timeZoneOffset =
    timeZone in ConstOffsetTimeZone.listTimeZoneByKey
      ? ConstOffsetTimeZone.listTimeZoneByKey[timeZone].offSet
      : DEFAULT_TIMEZONE;
  if (!dateTime) return dateTime;
  const time = moment(dateTime)
    .format(FORMAT_DATE)
    .toString();
  return `${time}T${isStart ? '00:00:00' : '23:59:00'} ${timeZoneOffset}`;
};
